class Elementor_Product_Cate_Carousel{
    static instance;

    static getInstance() {
        if (!Elementor_Product_Cate_Carousel.instance) {
            Elementor_Product_Cate_Carousel.instance = new Elementor_Product_Cate_Carousel();
        }
        return Elementor_Product_Cate_Carousel.instance;
    }

    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-product-categories-carousel.default', ( $scope ) => {
            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }

        } );
    }
}


Elementor_Product_Cate_Carousel.getInstance();